import { useState, useCallback, useMemo, useEffect } from 'react';
import { map, get } from 'lodash';
import { AuditFiltersService } from '../services/auditFiltersService';

export const useAuditFilters = (session) => {
    const userSalesChannels = get(session, 'salesChannels', []);

    const [filters, setFilters] = useState({
        dateSelected: {
            init: new Date(),
            end: new Date()
        },
        salesChannels: map(userSalesChannels, 'id')
    });

    const [filtersApplied, setFiltersApplied] = useState(false); 

    const getSources = (salesChannelsSelected) => {
        const storesFiltered = AuditFiltersService.createSalesChannelItems(userSalesChannels, salesChannelsSelected);
        return storesFiltered
    };

    const onSubmitFilters = ({ salesChannels, dateSelected, status, ...values }, callback) => {
        const sources = getSources(map(get(salesChannels, 'value', []), 'value'));

        callback(dateSelected);
        setFilters({
            salesChannels: map(sources, 'value'),
            status: [32].map(String),
            dateSelected,
            ...values
        });
        setFiltersApplied(true);
    };
        
    useEffect(() => {
        if (filters.salesChannels.length === 0 && userSalesChannels.length > 0) {
          setFilters(prev => ({
            ...prev,
            salesChannels: map(userSalesChannels, 'id')
          }));
        }
      }, [userSalesChannels]);


    const queryFilters = useMemo(() => {
        const sources = getSources();
        // Tu lógica actual para construir los filtros
        return AuditFiltersService.buildQueryFilters(filters, sources, filtersApplied);
    }, [filters, filtersApplied]); // Solo dependencias que realmente importan

    // const getQueryFilters = () => {
    //     const sources = getSources();
    //     return AuditFiltersService.buildQueryFilters(filters, sources, filtersApplied);
    // };

    const getQueryFilters = useCallback(() => {
        return queryFilters;
    }, [queryFilters]);

    return {
        filters,
        filtersApplied,
        sources: getSources(),
        onSubmitFilters,
        getQueryFilters
    };
};